"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSAK_PRIORITY_COUNTRIES = exports.MERCURYO_PRIORITY_COUNTRIES = exports.BANXA_PRIORITY_COUNTRIES = exports.RAMP_PRIORITY_COUNTRIES = exports.CEX_PRIORITY_COUNTRIES = exports.SIMPLEX_PRIORITY_COUNTRIES = exports.MOONPAY_PRIORITY_COUNTRIES = void 0;
// 100% users from these regions redirected to associated provider
exports.MOONPAY_PRIORITY_COUNTRIES = [
    "DZ",
    "AM",
    "AT",
    "BI",
    "CF",
    "CR",
    "SV",
    "GT",
    "GW",
    "HN",
    "ID",
    "LV",
    "LY",
    "ML",
    "NP",
    "LC",
    "SO",
    "LK",
    "US",
];
exports.SIMPLEX_PRIORITY_COUNTRIES = [
    "BB",
    "CU",
    "FK",
    "GF",
    "HT",
    "XK",
    "LR",
    "MM",
    "AN",
    "NI",
    "PS",
    "PA",
    "SL",
];
exports.CEX_PRIORITY_COUNTRIES = ["CN", "CD", "EC", "VE"];
exports.RAMP_PRIORITY_COUNTRIES = [];
exports.BANXA_PRIORITY_COUNTRIES = ["BD", "BO", "PF", "MV", "MA"];
exports.MERCURYO_PRIORITY_COUNTRIES = [
    "AL",
    "AG",
    "AI",
    "AW",
    "BS",
    "BY",
    "BJ",
    "BQ",
    "BV",
    "IO",
    "CI",
    "KY",
    "TD",
    "CX",
    "CC",
    "KM",
    "CK",
    "CW",
    "DJ",
    "GQ",
    "ER",
    "SZ",
    "TF",
    "GE",
    "GH",
    "GP",
    "GN",
    "HM",
    "VA",
    "JM",
    "JP",
    "KZ",
    "KI",
    "KW",
    "LS",
    "LU",
    "MG",
    "MQ",
    "MR",
    "MU",
    "YT",
    "FM",
    "MS",
    "NR",
    "NC",
    "NE",
    "NU",
    "NF",
    "MK",
    "MP",
    "OM",
    "PW",
    "PN",
    "PR",
    "RU",
    "RW",
    "BL",
    "PM",
    "WS",
    "SX",
    "KP",
    "SJ",
    "TZ",
    "TL",
    "TG",
    "TK",
    "TT",
    "TC",
    "TV",
    "UG",
    "VU",
    "WF",
    "EH",
];
exports.TRANSAK_PRIORITY_COUNTRIES = [
    "AX",
    "CL",
    "DK",
    "IN",
    "PE",
    "PH",
    "SM",
    "TH",
    "GB",
    "UY",
];
//# sourceMappingURL=priorityCountries.js.map